import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { lightable, LightningProps } from 'owa-lightning-v2';
import { UpsellBannerComponent } from 'owa-upsell-components';

export interface TopUpsellBannerProps extends LightningProps {
    bannerClass: string;
}

export const TopUpsellBannerPlaceHolder = lightable(
    observer(function TopUpsellBannerPlaceHolder(props: TopUpsellBannerProps) {
        return (
            <div className={props.bannerClass}>
                <UpsellBannerComponent
                    lid={props.lid} // lightning id for callout
                />
            </div>
        );
    })
);
